import React from "react";


  
const AccountDropdown = (props)=>{

    return(
      <ul className="dropdown">
        { props.accounts.map((acc)=>(
          <>
            {!acc.deletedTimeStampUserTz &&
            <li key={acc.id} onClick={p=>props.selectionChanged(acc)}>
              <div>
                <div><span>Account Numner : </span><span>{acc.accountNumber}</span></div>
                <div><span>Financial Institute : </span><span>{acc.brokerDealerName}</span></div>
              </div>
            </li>
            }
          </>
        ))
        }
        <li key="OTHER" onClick={p => props.selectionChanged({ accountNumber: "", brokerDealerName: "" })}><div><span>Other...</span></div></li>
      </ul>
    )

  };



  export default AccountDropdown;